import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ExperienceAreaService } from '../experience-area.service';
import { ExperienceOverviewService } from './experience-overview.service';
import { ExperienceOverviewTab1Part } from './tabs/tab-1/experience-overview-tab-1.part';
import { ExperienceOverviewTab2Part } from './tabs/tab-2/experience-overview-tab-2.part';
import { ExperienceOverviewViewsPart } from './views/overview-views.part';

@Component({
	selector: 'experience-overview-page',
	standalone: true,
	imports: [
		ExperienceOverviewTab1Part, ExperienceOverviewTab2Part, ExperienceOverviewViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-overview.page.html',
})
export class ExperienceOverviewPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public experienceService = inject(ExperienceAreaService);


	constructor(
		public pageService: ExperienceOverviewService,
	) {
	}

	async ngOnInit() {
		await this.experienceService.loadExperienceData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}